import { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { toast } from "react-toastify";
import "../../style/AuthForm.css";
import Axios from "../../utils/axios";

const ResetPasswordForm = ({ email, onBackToLogin }) => {
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isOtpValid, setIsOtpValid] = useState(false);

  // Step 1: Verify OTP
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_AUTH_BASE_URL}/api/forgotPassword/verifyotp`,
        { email, otp }
      );
      toast.success(res.data?.message || "OTP verified!");
      setIsOtpValid(true);
    } catch (error) {
      toast.error(error.response?.data?.message || "Invalid OTP");
      setIsOtpValid(false);
    }
  };

  // Step 2: Reset password
  const handlePasswordResetSubmit = async (e) => {
    e.preventDefault();

    const trimmedNewPassword = newPassword.trim();
    const trimmedConfirmNewPassword = confirmNewPassword.trim();

    if (trimmedNewPassword === "" || trimmedConfirmNewPassword === "") {
      setErrors({ confirmNewPassword: "Passwords cannot be empty." });
      return;
    }

    if (trimmedNewPassword !== trimmedConfirmNewPassword) {
      setErrors({ confirmNewPassword: "Passwords do not match." });
      return;
    }

    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_AUTH_BASE_URL}/api/forgotPassword/reset`,
        {
          email,
          otp,
          newPassword: trimmedNewPassword,
          confirmNewPassword: trimmedConfirmNewPassword,
        }
      );
      toast.success(res.data?.message || "Password reset successfully!");
      onBackToLogin();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to reset password");
    }
  };

  return (
    <div className="auth-container">
      <div className="form-box">
        <div className="form-header">
          <h2>Reset Password</h2>
        </div>

        <form
          onSubmit={isOtpValid ? handlePasswordResetSubmit : handleOtpSubmit}
        >
          {/* OTP input */}
          <div className="form-group">
            <label htmlFor="resetOtp">OTP</label>
            <input
              type="text"
              id="resetOtp"
              value={otp}
              onChange={(e) => {
                setOtp(e.target.value);
                if (errors.otp) setErrors({ ...errors, otp: "" });
              }}
              placeholder="Enter OTP from email"
              required
              disabled={isOtpValid}
            />
            {errors.otp && <p className="error-message">{errors.otp}</p>}
          </div>

          {!isOtpValid && <button type="submit">Verify OTP</button>}

          {isOtpValid && (
            <>
              {/* New Password */}
              <div className="form-group">
                <label htmlFor="newPassword">New Password</label>
                <div className="password-wrapper">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    id="newPassword"
                    value={newPassword}
                    onChange={(e) => {
                      setNewPassword(e.target.value);
                      if (errors.confirmNewPassword)
                        setErrors({ ...errors, confirmNewPassword: "" });
                    }}
                    placeholder="Enter new password"
                    required
                  />
                  <span
                    className="toggle-password"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    {showNewPassword ? <FiEyeOff /> : <FiEye />}
                  </span>
                </div>
              </div>

              {/* Confirm New Password */}
              <div className="form-group">
                <label htmlFor="confirmNewPassword">confirmNewPassword</label>
                <div className="password-wrapper">
                  <input
                    type={showConfirmNewPassword ? "text" : "password"}
                    id="confirmNewPassword"
                    value={confirmNewPassword}
                    onChange={(e) => {
                      setConfirmNewPassword(e.target.value);
                      if (errors.confirmNewPassword)
                        setErrors({ ...errors, confirmNewPassword: "" });
                    }}
                    placeholder="Confirm new password"
                    required
                  />
                  <span
                    className="toggle-password"
                    onClick={() =>
                      setShowConfirmNewPassword(!showConfirmNewPassword)
                    }
                  >
                    {showConfirmNewPassword ? <FiEyeOff /> : <FiEye />}
                  </span>
                </div>
                {errors.confirmNewPassword && (
                  <p className="error-message">{errors.confirmNewPassword}</p>
                )}
              </div>

              <button type="submit">Reset Password</button>
            </>
          )}

          <div className="form-toggle">
            <p onClick={onBackToLogin}>Back to Login</p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
